import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';

const StyledDescription = styled.p`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
  font-size: 14px;
  line-height: 20px;

  ${media.md`
    font-size: 16px;
    line-height: inherit;
  `}
`;

type DescriptionProps = {
  description: string;
};

export const Description: FC<DescriptionProps> = ({ description }) => {
  if (!description) {
    return null;
  }

  return <StyledDescription>{description}</StyledDescription>;
};
